import { render, staticRenderFns } from "./BangkokOfficerHistory.vue?vue&type=template&id=b04224fc&"
import script from "./BangkokOfficerHistory.vue?vue&type=script&lang=js&"
export * from "./BangkokOfficerHistory.vue?vue&type=script&lang=js&"
import style0 from "./BangkokOfficerHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports